import { Grid } from '@mui/material'
import ScrollHOC from 'platform/react/hoc/scroll'

export default ScrollHOC(Grid)
